module.exports = __webpack_public_path__ + "img/share-tip.006559de.png";